/* Naturally Good Snacks collection pages: craving filters, sorting, bag-size pickers, promo tiles. */
(function () {
  if (window.__ngsColl) return;
  window.__ngsColl = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var bar = $('[data-ngs-shipbar]');
  var moneyFormat = (bar && bar.dataset.moneyFormat) || '${{amount}}';
  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2).split('.');
    var whole = n[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    if (/amount_no_decimals/.test(moneyFormat)) return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, whole);
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, whole + '.' + n[1]);
  }

  $$('[data-ngs-coll]').forEach(function (sec) {
    var grid = $('[data-ngs-grid]', sec);
    if (!grid) return;
    var cards = $$('[data-ngs-card]', grid);
    var promos = $$('[data-ngs-promo]', grid);
    var chips = $$('[data-ngs-chip]', sec);
    var sortSel = $('[data-ngs-sort]', sec);
    var more = $('[data-ngs-more]', sec);
    var empty = $('[data-ngs-empty]', sec);
    var countEl = $('[data-ngs-result-count]', sec);
    var perPage = parseInt(sec.dataset.perPage, 10) || 16;
    var countText = sec.dataset.countText || '[count] snacks';
    var threshold = parseInt(sec.dataset.threshold, 10) || 5900;
    var freeNote = sec.dataset.freeNote || '';
    var valueNote = sec.dataset.valueNote || '';
    var upsellNote = sec.dataset.upsellNote || '';
    var shown = perPage;
    var active = [];
    cards.forEach(function (c) { c._tags = (c.dataset.tags || '').split('|').filter(Boolean); });

    function matches(c, list) { return list.every(function (t) { return c._tags.indexOf(t) > -1; }); }

    function readState() {
      var m = location.hash.match(/craving=([^&]+)/);
      if (m) active = decodeURIComponent(m[1]).split(',').filter(function (t) { return chips.some(function (c) { return c.dataset.ngsChip === t; }); });
      var s = location.hash.match(/sort=([^&]+)/);
      if (s && sortSel) sortSel.value = decodeURIComponent(s[1]);
    }
    function writeState() {
      var parts = [];
      if (active.length) parts.push('craving=' + encodeURIComponent(active.join(',')));
      if (sortSel && sortSel.value !== 'featured') parts.push('sort=' + sortSel.value);
      var h = parts.length ? '#shop&' + parts.join('&') : '';
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + h);
    }

    function render() {
      chips.forEach(function (c) {
        var t = c.dataset.ngsChip;
        c.setAttribute('aria-pressed', t === '' ? String(active.length === 0) : String(active.indexOf(t) > -1));
        var em = $('[data-ngs-chip-count]', c);
        if (em) {
          var next = active.indexOf(t) > -1 ? active : active.concat([t]);
          var n = cards.filter(function (card) { return matches(card, next); }).length;
          em.textContent = n;
          c.classList.toggle('is-zero', n === 0 && active.indexOf(t) === -1);
        }
      });
      var list = cards.filter(function (c) { return matches(c, active); });
      var mode = sortSel ? sortSel.value : 'featured';
      list.sort(function (a, b) {
        if (mode === 'price-asc') return a.dataset.price - b.dataset.price;
        if (mode === 'price-desc') return b.dataset.price - a.dataset.price;
        if (mode === 'value') return a.dataset.perlb - b.dataset.perlb;
        if (mode === 'title') return a.dataset.title < b.dataset.title ? -1 : 1;
        return a.dataset.order - b.dataset.order;
      });
      cards.forEach(function (c) { c.hidden = true; });
      promos.forEach(function (p) { p.hidden = true; });
      var visible = Math.min(shown, list.length);
      var slots = {};
      promos.forEach(function (p) { var n = parseInt(p.dataset.after, 10) || 6; if (n < visible) (slots[n] = slots[n] || []).push(p); });
      list.forEach(function (c, i) {
        grid.appendChild(c);
        c.hidden = i >= shown;
        (slots[i + 1] || []).forEach(function (p) { grid.appendChild(p); p.hidden = false; });
      });
      promos.forEach(function (p) { if (p.hidden) grid.appendChild(p); });
      if (more) more.hidden = list.length <= shown;
      if (empty) empty.hidden = list.length > 0;
      if (countEl) countEl.textContent = countText.replace('[count]', list.length);
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var t = c.dataset.ngsChip;
        if (t === '') active = [];
        else if (active.indexOf(t) > -1) active = active.filter(function (x) { return x !== t; });
        else active = active.concat([t]);
        shown = perPage;
        render(); writeState();
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { render(); writeState(); });
    if (more) more.addEventListener('click', function () { shown += perPage; render(); });
    if (chips.length <= 1) { var cb = $('.coll-bar', sec); if (cb) cb.classList.add('no-chips'); }
    readState();
    render();

    /* bag size pickers */
    $$('.coll-form', sec).forEach(function (form) {
      var sizes = $$('[data-ngs-size]', form);
      var vid = $('[data-ngs-vid]', form);
      var priceEl = $('[data-ngs-price]', form);
      var perEl = $('[data-ngs-perlb]', form);
      var note = $('[data-ngs-note]', form);
      var base = null, best = null;
      sizes.forEach(function (b) {
        var lbs = parseFloat(b.dataset.lbs) || 0;
        b._per = lbs ? parseInt(b.dataset.price, 10) / lbs : 0;
        if (lbs && (!base || lbs < base.lbs)) base = { lbs: lbs, per: b._per, label: b.textContent.trim() };
        if (lbs && !b.disabled && (!best || b._per < best.per)) best = { per: b._per, label: b.textContent.trim(), el: b };
      });
      function pick(b) {
        sizes.forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
        var price = parseInt(b.dataset.price, 10);
        vid.value = b.dataset.id;
        if (priceEl) priceEl.textContent = money(price);
        if (perEl) perEl.textContent = b._per ? money(b._per) + '/lb' : '';
        var msg = '';
        if (price >= threshold && freeNote) msg = freeNote;
        if (base && b._per && b._per < base.per - 1) {
          var pct = Math.round((1 - b._per / base.per) * 100);
          var v = valueNote.replace('[percent]', pct + '%').replace('[size]', base.label);
          msg = msg ? v + '. ' + msg : v;
        } else if (upsellNote && best && best.el !== b && b._per && best.per < b._per - 1) {
          var up = Math.round((1 - best.per / b._per) * 100);
          msg = upsellNote.replace('[percent]', up + '%').replace('[size]', best.label);
        }
        if (note) { note.textContent = msg; note.classList.toggle('is-on', !!msg); }
      }
      sizes.forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled) pick(b); }); });
      var cur = sizes.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || sizes[0];
      if (cur) pick(cur);
      else if (perEl) {
        var card = form.closest('[data-ngs-card]');
        if (card && card.dataset.perlb && card.dataset.perlb !== card.dataset.price) perEl.textContent = money(parseInt(card.dataset.perlb, 10)) + '/lb';
        var p = card ? parseInt(card.dataset.price, 10) : 0;
        if (note && p >= threshold && freeNote) { note.textContent = freeNote; note.classList.add('is-on'); }
      }
    });
  });
})();
